import React from "react";

const defaultLocationData = [
  { location: "Rural", current: "", previous: "" },
  { location: "Semi-Urban", current: "", previous: "" },
  { location: "Urban", current: "", previous: "" },
  { location: "Metropolitan", current: "", previous: "" },
];

const LocationDistributionTable = ({ locationData, setLocationData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...locationData];
    updated[index][field] = value;
    setLocationData(updated);
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={header}>Location</th>
            <th style={header}>
              FY _____ <br />
              Current Financial Year
            </th>
            <th style={header}>
              FY _____ <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {locationData.map((row, index) => (
            <tr key={index}>
              <td style={{ ...cell, fontWeight: "bold" }}>{row.location}</td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Current FY"
                  value={row.current}
                  onChange={(e) =>
                    handleChange(index, "current", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Previous FY"
                  value={row.previous}
                  onChange={(e) =>
                    handleChange(index, "previous", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LocationDistributionTable;
